import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";

export default {
  fetchKeywords({ page = 1, page_size = 20, signal, ...payload } = {}) {
    return apiService.post(endpoints.keywordImpressions.list, payload, {
      signal,
      params: { page, page_size }
    });
  },

  fetchSummary(data = {}, options = {}) {
    return apiService.post(endpoints.keywordImpressions.summary, data, options);
  },

  fetchTopKeywordsSummary(data = {}, options = {}) {
    return apiService.post(endpoints.keywordImpressions.topKeywords, data, options);
  },

  fetchTopKeywords({ page = 1, page_size = 20, signal, ...payload } = {}) {
    return apiService.post(endpoints.keywordImpressions.keywords, payload, {
      signal,
      params: { page, page_size }
    });
  },

  fetchKeywordByDate(data = {}, options = {}) {
    return apiService.post(endpoints.keywordImpressions.byDate, data, options);
  },

  fetchDates(data = {}) {
    return apiService.post(endpoints.keywordImpressions.dates, data);
  },

  exportKeywords(data = {}) {
    return apiService.post(endpoints.keywordImpressions.export, data);
  }
};
